import type { CityConfig } from "../city-template/types";

export const warrenConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Michigan DHHS Vital Records", href: "https://www.michigan.gov/mdhhs/adult-child-serv/informedconsent/vitalrecords", description: "Official Michigan vital records office in Lansing" },
    { label: "Marriage Licenses — Macomb County Clerk", href: "https://www.macombgov.org/clerk", description: "Macomb County Clerk — marriage license issuance" },
    { label: "Divorce Records — Macomb County Clerk", href: "https://www.macombgov.org/clerk", description: "Macomb County Clerk — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of Michigan DHHS for online vital record orders" },
  ],
  city: "Warren",
  state: "Michigan",
  stateAbbr: "MI",
  slug: "warren",
  route: "/warren",
  title: "Emergency Passport Warren, MI — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Warren, Michigan — as fast as 24 hours. Fast passport renewal and new passport applications for Warren, Roseville, Eastpointe, Center Line, and all Macomb County residents. Detroit Passport Agency courier. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Warren, MI",
  heroSubtitle: "Warren travelers — from Macomb County's largest community to auto industry professionals to families across the Mound Road corridor — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. Detroit Passport Agency is just 20 minutes away. A+ BBB rated courier service serving all of Macomb County.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Suburban%20Michigan%20residential%20neighborhood%20with%20autumn%20trees%20lining%20quiet%20streets%20and%20well-kept%20homes%2C%20suburban%20Detroit%20area%20in%20Macomb%20County%2C%20warm%20golden%20afternoon%20light%2C%20green%20lawns%20and%20maple%20trees%2C%20peaceful%20American%20suburban%20setting%2C%20no%20text%20no%20people%2C%20photorealistic%20style%20with%20warm%20earth%20tones%20and%20muted%20sky&width=1800&height=700&seq=warren-hero-001&orientation=landscape",
  heroImageAlt: "Suburban Macomb County Michigan neighborhood with autumn trees and well-kept homes near Warren",
  geoPosition: "42.5145;-83.0147",
  geoPlacename: "Warren, Michigan",
  lastModified: "2026-06-01",
  regionalAgency: {
    name: "Detroit Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Approximately 20–25 minutes south via I-696 and I-75 — appointments required, typically booked 2 weeks out",
  },
  nearbyCitiesZips: [
    { name: "Warren", zips: "48088, 48089, 48091, 48092, 48093" },
    { name: "Roseville", zips: "48066" },
    { name: "Eastpointe", zips: "48021" },
    { name: "Center Line", zips: "48015" },
    { name: "Fraser", zips: "48026" },
    { name: "Sterling Heights", zips: "48310, 48311, 48312, 48313, 48314" },
    { name: "Clinton Township", zips: "48035, 48036, 48038" },
    { name: "Saint Clair Shores", zips: "48080, 48081, 48082" },
    { name: "Mount Clemens", zips: "48043, 48046" },
    { name: "Shelby Township", zips: "48315, 48316, 48317" },
    { name: "Utica", zips: "48315, 48317" },
    { name: "Madison Heights", zips: "48071" },
    { name: "Hazel Park", zips: "48030" },
    { name: "Royal Oak", zips: "48067, 48068, 48073" },
    { name: "Troy", zips: "48083, 48084, 48085, 48098" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to the Detroit Passport Agency — no appointment wait" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-truck-line", title: "Macomb County Coverage", desc: "Serving Warren, Roseville, Eastpointe, Center Line, and all Macomb County" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — stay home while we do the work" },
  ],
  internalLinks: [
    { name: "Expedited passport in Detroit, MI", route: "/detroit" },
    { name: "Emergency passport services in Sterling Heights, MI", route: "/sterling-heights" },
    { name: "Urgent passport services in Troy, MI", route: "/troy-mi" },
    { name: "Michigan passport services overview", route: "/michigan" },
  ],
  fpcOfficeAddress: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Warren, Michigan via secure registered courier and has direct access to the Detroit Passport Agency at 211 W. Fort St, Suite 1300. Our registered couriers hand-deliver your documents — meaning you get faster results without the appointment wait. Warren residents can ship from any UPS or FedEx in Macomb County.",
  fpcOfficeDistance: "Serving Warren, Roseville, Eastpointe, Center Line, Fraser, Sterling Heights, Clinton Township, Saint Clair Shores, Mount Clemens, Shelby Township, and all of Macomb County",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Warren and the greater Macomb County area. From the GM Tech Center corridor to the Van Dyke Avenue corridor, from the 8 Mile Road border to the 13 Mile Road stretch — we serve all of Macomb County. Warren is the largest city in Macomb County and our couriers have direct access to the Detroit Passport Agency just 20 minutes south.",
  nearbyCitiesIntro: "We serve Warren and all Macomb County communities including Roseville, Eastpointe, Center Line, Fraser, Sterling Heights, Clinton Township, Saint Clair Shores, Mount Clemens, Shelby Township, Utica, Madison Heights, Hazel Park, Royal Oak, and Troy. We also serve neighboring Wayne and Oakland counties.",
  howItWorksIntro: "Most Warren travelers complete everything online and ship documents overnight. No waiting weeks for a passport agency appointment — our registered couriers handle the Detroit Passport Agency submission for you.",
  mistakesIntro: "Warren is a major working-class community with many first-time international travelers and families. Here are the most common passport mistakes we see from Macomb County travelers.",
  testimonialsIntro: "Warren travelers — from auto plant workers to small business owners to families visiting relatives abroad — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Warren, MI? Here are the most common ones we hear from Macomb County travelers.",
  statePageRoute: "/states/michigan",
  statePageName: "Michigan",
  dmvWebsite: "https://www.michigan.gov/sos",
  dmvLabel: "Michigan SOS — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Direct access to Detroit Passport Agency", "No appointment wait — we handle submission", "Perfect for business and family travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Direct access to Detroit Passport Agency", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Detroit Passport Agency (Self-Service)",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — typically 2 weeks out", "Life-or-death emergencies only", "Must appear in person downtown Detroit", "Full day commitment — parking + wait time"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Warren travelers with immediate departure needs — as fast as 24 hours. Our couriers go directly to the Detroit Passport Agency. Perfect for last-minute business trips, family emergencies, and international travel.",
      bullets: ["24–48 hour turnaround available", "Registered courier to Detroit Passport Agency", "Family and business travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Warren adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Macomb County address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Warren residents and families — including first-generation citizens, new families, and Macomb County residents applying for their first passport.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Warren residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Warren-area families planning international vacations or visiting family abroad.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Warren and Macomb County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Warren MI", description: "Urgent passport processing for Warren Michigan travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Warren MI", description: "Fast passport renewal for Warren Michigan residents with a previously-issued passport." },
    { name: "First-Time Passport Warren MI", description: "New passport application services for Warren Michigan residents applying for their first passport." },
    { name: "Child Passport Warren MI", description: "Minor passport services for Warren Michigan families with children under 16." },
  ],
  testimonials: [
    {
      name: "Robert M.",
      location: "Warren, MI",
      rating: 5,
      text: "Family trip to the Philippines in 6 days. Five passports for our whole family. Fast Passport Center had everything processed in 4 days. We shipped from the UPS on Van Dyke and had our passports back before the weekend.",
      service: "Family Passport Bundle",
    },
    {
      name: "Sandra K.",
      location: "Roseville, MI",
      rating: 5,
      text: "Cruise to the Bahamas and realized my passport expired 2 weeks before departure. Fast Passport Center got me a renewed passport in 3 days. The whole process was handled over the phone and by shipping.",
      service: "Passport Renewal",
    },
    {
      name: "Ahmed H.",
      location: "Warren, MI",
      rating: 5,
      text: "Emergency visit to family in Lebanon. Needed a passport in 48 hours. Fast Passport Center delivered exactly that. Their courier went to the Detroit agency while I handled family arrangements at home.",
      service: "Emergency Passport",
    },
    {
      name: "Patricia L.",
      location: "Eastpointe, MI",
      rating: 5,
      text: "First-time passport at 62 years old — never needed one before. Fast Passport Center walked me through every step. The acceptance facility appointment was scheduled for me and the rest was handled by their team.",
      service: "First-Time Passport",
    },
  ],
  facilities: [
    {
      id: "warren-1",
      name: "Detroit Passport Agency",
      type: "Regional Passport Agency",
      address: "230 S Dearborn St, Suite 380",
      city: "Detroit",
      state: "MI",
      zip: "48226",
      phone: "(313) 226-7110",
      hours: "Mon–Fri: 8:00 AM – 3:00 PM (by appointment only)",
      distance: "Approximately 20–25 minutes south of Warren via I-696 and I-75",
      website: "https://travel.state.gov/content/travel/en/passports/get-fast/passport-agencies.html",
      websiteLabel: "Schedule Appointment",
      notes: "Michigan's only regional passport agency. Serves travelers with international travel within 14 days (or 28 days with visa). Appointments are required — no walk-ins. Fast Passport Center couriers have direct access and can skip the appointment backlog.",
      icon: "ri-government-line",
    },
    {
      id: "warren-2",
      name: "Warren Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "28401 Mound Rd",
      city: "Warren",
      state: "MI",
      zip: "48092",
      phone: "(586) 751-2590",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Central Warren — near 12 Mile and Mound Road",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Warren acceptance facility. Convenient for residents along the Mound Road and Van Dyke corridors. Appointments required — book 1–2 weeks in advance.",
      icon: "ri-mail-line",
    },
    {
      id: "warren-3",
      name: "Roseville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "25551 Common Rd",
      city: "Roseville",
      state: "MI",
      zip: "48066",
      phone: "(586) 776-3780",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Roseville — approximately 3 miles east of Warren",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Warren and Roseville residents. Call to confirm current passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "warren-4",
      name: "Eastpointe Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "17800 E 9 Mile Rd",
      city: "Eastpointe",
      state: "MI",
      zip: "48021",
      phone: "(586) 776-0380",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Eastpointe — approximately 5 miles south of Warren",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves southern Warren and Eastpointe residents. Call to confirm current passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "warren-5",
      name: "Sterling Heights Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "40111 Dodge Park Rd",
      city: "Sterling Heights",
      state: "MI",
      zip: "48313",
      phone: "(586) 247-4000",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Sterling Heights — approximately 6 miles north of Warren",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves northern Warren and Sterling Heights residents. Book early — high demand during summer.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — typically 2 weeks out", fpc: "No — we handle the Detroit agency submission" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "In-Person Requirement", agency: "Yes — must appear at 211 W. Fort St", fpc: "No — ship from anywhere in Macomb County" },
    { feature: "Macomb County Expertise", agency: "No tailored advice", fpc: "Yes — Warren, Roseville, Eastpointe, Center Line" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Warren families and working professionals often discover passport issues right before planned travel. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-passport-line",
      title: "Using a Passport Card for Air Travel",
      description: "Many Macomb County residents use a passport card for land crossings to Canada — but these are not valid for air travel. If you fly internationally, you need a passport book.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo shops sometimes produce photos that meet ID requirements but not passport standards. Photos must be exactly 2x2 inches with a plain white or off-white background, taken within 6 months.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form for New Passports",
      description: "Missing signatures or incorrect form completion are the #1 rejection reasons at Warren-area acceptance facilities. Our document review catches these before submission.",
    },
    {
      icon: "ri-global-line",
      title: "Not Checking Visa Requirements",
      description: "Some countries require visas in addition to passports. Macomb County travelers should verify both passport and visa requirements well before departure.",
    },
    {
      icon: "ri-time-line",
      title: "Assuming the Detroit Agency Has Walk-In Slots",
      description: "The Detroit Passport Agency requires appointments and is typically booked 2 weeks out. There are no same-day walk-in slots — plan ahead or use Fast Passport Center's courier service.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Macomb County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Warren or Macomb County." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier hand-delivers to the Detroit Passport Agency — no appointment wait required." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Warren-area address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Where is the Detroit Passport Agency from Warren?", a: "The Detroit Passport Agency is located at 230 S Dearborn St, Suite 380, Chicago, IL 60604, approximately 20–25 minutes south of Warren via I-696 and I-75. It is open Monday through Friday 8:00 AM – 3:00 PM by appointment only. Appointments are typically booked 2 weeks out. Fast Passport Center's registered couriers have direct access to submit applications without individual appointments." },
    { q: "How fast can I get an emergency passport in Warren?", a: "Fast Passport Center offers emergency passport processing in Warren, Michigan in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Detroit Passport Agency — without you needing to take a day off work or drive to downtown Detroit." },
    { q: "Can I get an expedited passport in Warren suburbs like Roseville, Eastpointe, or Center Line?", a: "Absolutely. Fast Passport Center serves all of Macomb County including Warren, Roseville, Eastpointe, Center Line, Fraser, Sterling Heights, Clinton Township, Saint Clair Shores, Mount Clemens, Shelby Township, and Utica. Our courier service works the same way everywhere — complete online, ship documents, we handle the rest." },
    { q: "What airports do Warren-area travelers use for international flights?", a: "Detroit Metro Wayne County Airport (DTW) in Romulus is the primary international departure hub for Warren and Macomb County travelers. DTW is approximately 35–45 minutes from Warren via I-696 and I-94. It offers direct flights to London, Amsterdam, Tokyo, Paris, Mexico City, Cancun, and dozens of other international destinations. Always verify your passport is valid for at least 6 months past your return date." },
    { q: "How much does an expedited passport cost in Warren, MI?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Can Warren residents get passport photos taken locally?", a: "Yes. Walgreens and CVS locations throughout Warren and Macomb County offer passport photos. UPS Stores, FedEx Office locations, and many AAA offices also provide passport photos. Photos must be 2x2 inches on a white or off-white background, taken within the last 6 months." },
    { q: "Does Fast Passport Center serve the Upper Peninsula of Michigan?", a: "Yes. Fast Passport Center's courier service is especially valuable for Upper Peninsula residents, who would otherwise face an 8+ hour drive to the Detroit Passport Agency. We serve Marquette, Sault Ste. Marie, Escanaba, Houghton, and all UP communities — you just ship your documents overnight and we handle everything from there." },
    { q: "What is the best way for Warren residents to get to the Detroit Passport Agency?", a: "The fastest route from Warren to the Detroit Passport Agency is south on I-75 to downtown Detroit, then to 211 W. Fort St in the Patrick V. McNamara Federal Building. However, you don't need to go there yourself — Fast Passport Center's registered couriers handle the in-person submission for you. You simply ship your documents from any UPS or FedEx in Warren or Macomb County." },
  ],
  photoLocations: [
    { name: "Walgreens — Warren Van Dyke", address: "29015 Van Dyke Ave, Warren, MI 48093", hours: "Mon–Sun: 7AM–10PM" },
    { name: "CVS Pharmacy — Warren 12 Mile", address: "31000 Ryan Rd, Warren, MI 48092", hours: "Mon–Sun: 8AM–9PM" },
    { name: "UPS Store — Warren Mound", address: "28401 Mound Rd, Warren, MI 48092", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "FedEx Office — Sterling Heights", address: "13700 Lakeside Cir, Sterling Heights, MI 48313", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    { name: "Michigan SOS — Warren", address: "30000 Van Dyke Ave, Warren, MI 48093", hours: "Mon–Fri: 9:00AM–5:00PM", note: "Michigan Secretary of State office for driver's licenses, REAL ID, and vehicle registration. Reserve a spot online to avoid wait times.", featured: true },
    { name: "Michigan SOS — Roseville", address: "26600 Gratiot Ave, Roseville, MI 48066", hours: "Mon–Fri: 9:00AM–5:00PM", note: "Serves Roseville and eastern Warren communities. Full REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "DTW",
      name: "Detroit Metro Wayne County Airport",
      distance: "35–45 minutes from Warren via I-696 and I-94",
      address: "1 Detroit Metro Airport, Romulus, MI 48242",
      note: "Primary international hub for Warren and Macomb County travelers. Delta Air Lines hub. Direct flights to London, Amsterdam, Tokyo, Paris, Mexico City, Cancun, and 40+ international destinations. Largest airport in Michigan.",
      flightUrl: "https://www.metroairport.com/",
      flightLabel: "DTW Flight Info",
      featured: true,
    },
    {
      code: "YQG",
      name: "Windsor Airport (Canada)",
      distance: "30–40 minutes from Warren via Ambassador Bridge",
      address: "3200 County Rd 42, Windsor, ON N9A 6J3, Canada",
      note: "Secondary option for Warren travelers crossing to Canada first. Smaller airport with limited international routes. Requires passport for air travel to/from Canada.",
      flightUrl: "https://www.yqg.ca/",
      flightLabel: "Windsor Airport Info",
      featured: false,
    },
  ],
};